import faq from "./_faq.js";
import hamburger from "./othres/_hamburger.js";
import basicsBadge from "./basics/_badge.js";
import formsSelect from "./forms/_select.js";
import othersHeadAlert from "./others/_head-alert.js";
import othersSearchList from "./others/_search-list.js";
import othersSearchMenu from "./others/_search-menu.js";
import othersSelectSearch from "./othres/_select-search.js";
import cardsEstate from "./cards/_estate.js";
import buttonsFavorite from "./buttons/_favorite.js";
import buttonsDownload from "./buttons/_download.js";

const components = () => {
    faq();
    basicsBadge();
    formsSelect();
    othersHeadAlert();
    othersSearchList();
    othersSearchMenu();
    hamburger();
    othersSelectSearch();
    cardsEstate();
    buttonsFavorite();
    buttonsDownload();
};

export default components;
